/**
 * Applies brand_config from bootstrap onto CSS custom properties.
 * Called once after bootstrap completes; safe to call again on config refresh.
 */

import type { BrandConfig } from "./kiosk-client";

export function applyBrandConfig(cfg: BrandConfig): void {
  const root = document.documentElement;
  const set = (key: string, val: string | undefined) => {
    if (val) root.style.setProperty(key, val);
  };
  set("--kiosk-brand-primary", cfg.primary_color);
  set("--kiosk-brand-accent", cfg.accent_color);
  set("--kiosk-brand-bg", cfg.background_color);
  set("--kiosk-brand-surface", cfg.surface_color);
  set("--kiosk-brand-text", cfg.text_color);
  set("--kiosk-brand-muted", cfg.muted_color);
  set("--kiosk-brand-radius", cfg.border_radius);
}
